<template>
  <PanelRow class="deviceview">
    <div class="panel compact">
      <header class="center">
        <h4>{{ 'feelgrid:puredata.single_device' | trans }}</h4>
      </header>
      <div class="controls">
        <div class="input-group">
          <label>{{ 'feelgrid:devices.select.label_one' | trans }}</label>
          <select v-model="device_id" class="form-control">
            <option v-for="device in available_devices" :value="device.id">
              {{ device.name | text }}
            </option>
          </select>
        </div>
        <IntervalSelector v-model="time_interval" @reload="reload" />
      </div>
      <div class="data-table" v-if="device">
        <div class="list-holder scrollable-table">
          <table v-if="list" class="itemstable">
            <thead><tr>
              <th class="time">{{ 'feelgrid:devices.data.fields.created_at' | trans }}</th>
              <th class="type" v-for="type in data_types.list">{{ type.title | text }}</th>
              <th class="padder"></th>
            </tr></thead>
            <tbody>
              <tr v-for="point in list.list">
                <td class="time"><Cell :field="{format: 'datetime'}" :item="point.created_at" /></td>
                <td class="value type" v-for="type in data_types.list">
                  {{ datapoint(point, type) | text }}
                </td>
                <td class="padder"></td>
              </tr>
            </tbody>
          </table>
          <Loading v-else />
        </div>
        <Pages class="center" v-model="p" :pages=pages />
      </div>
    </div>
  </PanelRow>
</template>

<script>
  import Cell from '@/helpers/components/display/Cell'
  import base from './base'
  import {sensor_value} from '../../helpers'
  import {async} from '@/helpers/mixins/pagination'
  
  export default {
    name: 'DeviceView',
    mixins: [base, async],
    components: {Cell},
    data () {return {
      device_id: false,
    }},
    computed: {
      device () {
        if (this.device_id) {
          var f = this.available_devices.filter(d => d.id === this.device_id);
          return f.length ? f[0] : false;
        }
      },
      data_types () {
        if (this.device) {
          return this.device.item.hardware_types.data_types;
        }
      },
      baseurl () {
        if (this.device) {
          var datas = this.data_types.map(t => _.snakeCase(t.name));
          return 'devices_data' +
            '?filter=devices_id::eq::' + this.device.id +
            ',' + this.date_range_filter +
            '&sort=id::desc' +
            '&include=' + datas.join(',')
          ;
        }
      },
    },
    methods: {
      datapoint (point, type) {
        var typename = _.snakeCase(type.name);
        if (!point[typename] || !point[typename].length) {
          return '-';
        }
        var data = point[typename].filtered('data_types_id', type.id);
        if (data && data.length) {
          return sensor_value(data.value, type);
        }
        return '';
      },
    },
    watch: {
      'available_devices.length' (l) {
        if (l) {
          this.device_id = this.available_devices[0].id;
        }
      },
    },
    mounted () {
      if (this.available_devices.length) {
        this.device_id = this.available_devices[0].id;
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/apps/feelgrid/modules/pureData/DeviceView.vue